import { Component, Input} from '@angular/core';
import { ModalComponent } from './modal';

@Component({
    selector: 'modal-footer',
    styles: [`
        .btn[hidden] { display: none; }
    `],
    template: `
        <div class="modal-footer">
            <ng-content></ng-content>
            <button type="button" class="btn btn-default" (click)="modal.dismiss()" [hidden]="!showDefaultButtons">Close</button>
            <button type="button" class="btn btn-primary" (click)="modal.close()" [hidden]="!showDefaultButtons">Save</button>
        </div>
    `,
    standalone: false
})
export class ModalFooterComponent {
    @Input('show-default-buttons') showDefaultButtons = false;
    constructor(public modal: ModalComponent) { }
}
